import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { keycloakService } from './modules/core_web/keycloak';
import { CollapseDrawerProvider } from './modules/core_web/minimals.cc/contexts/CollapseDrawerContext';
import { SettingsProvider } from './modules/core_web/minimals.cc/contexts/SettingsContext';

const renderApp = () =>
  ReactDOM.render(
    <StrictMode>
      <HelmetProvider>
        <SettingsProvider>
          <CollapseDrawerProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </CollapseDrawerProvider>
        </SettingsProvider>
      </HelmetProvider>
    </StrictMode>,
    document.getElementById('root')
  );

keycloakService.initKeycloak(renderApp);
